import Config from 'Config';
import axios from 'axios';
import { createSignedRequest } from 'utils/createSignedRequest';

export const patchUpdateKanbanTicket = async (
  projectId,
  ticketId,
  updates,
  imagesToAdd,
  imagesToDelete
) => {
  const apiPath = `kanban/project/${projectId}/ticket/${ticketId}/update-ticket`;

  const body = {
    updates,
    ...(imagesToAdd && imagesToAdd.length ? { imagesToAdd } : {}),
    ...(imagesToDelete && imagesToDelete.length ? { imagesToDelete } : {}),
  };

  const request = {
    // url: `http://localhost:3001/${apiPath}`,
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'PATCH',
    region: Config.AWS_REGION,
    service: 'execute-api',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
    data: body,
  };
  const signedRequest = await createSignedRequest(request);

  const response = await axios(signedRequest);

  return response.data;
};
